// This file can be replaced during build by using the `fileReplacements` array.

// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  hmr: false,
  qa: false,
  dev: false,
  local: true,
  pubNubChannelPrefix: 'dev_',
  s3_bucket_url: 'https://d1dlkn0qu1hpr5.cloudfront.net/',
  staging: false,
  // appUrl: 'http://localhost:8000/',
  appUrl: 'https://backend-office.msde.in/',
  chat_socket_url: 'https://chat-node-backend.volmint.com',
  // chat_socket_url: 'http://localhost:9000',
  chat_project_id: '69de26cd9e3b94bb6af5cbdc',

  // Firebase Web App config — fill these from Firebase Console >
  // Project Settings > General > Your apps > Web app > SDK setup
  firebase: {
    apiKey: 'AIzaSyCieSQR09FI0hg15CFdLoIa46gSxEQIOlo',
    authDomain: 'v-orbit-95466.firebaseapp.com',
    projectId: 'v-orbit-95466',
    storageBucket: 'v-orbit-95466.firebasestorage.app',
    messagingSenderId: '862067516926',
    appId: '1:862067516926:web:d4614532b2a5029b9cccaf',
    measurementId: "G-0L77RWJL3T",
    // Fill from: Firebase Console > Project Settings > Cloud Messaging >
    // Web configuration > Web Push certificates > Key pair
    vapidKey: 'BDcd-wpUmAkb6aAHGZ3dOL0VBnOJvKPGRC5FbuAz6HEsgfC2o9bTx9iWUXao2imh0P6QhJhmfRiJt0_CtxwhpRU',
  } 
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
